import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";

export enum WireTagEnum {
  SHA = 'SHA',
  OUR = 'OUR',
  BEN = 'BEN'
}

export class WirePaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.Wire

  get allTags() {
    return [
      WireTagEnum.SHA,
      WireTagEnum.OUR,
      WireTagEnum.BEN
    ]
  }

  required = [
    'amount', 'description', 'fromAccount', 'destinationAccount',
    'tag',
    'verificationType', 'label'
  ]

  options = {
    ...this.getOptions(),
    tags: [],
    beneficiaryAddressCountries: {},
    bankAddressCountries: {},
    beneficiaryCountriesData: [],
    bankCountriesData: []
  }

  values = {
    ...this.getValues(),
    beneficiaryCountry: '', beneficiary: '', beneficiaryAddress: '',
    fromAccount: '', tag: '', amount: '', label: '',
    verificationType: '', autosplit: false, destinationAccount: '',
    version: 2,
    beneficiaryBankSWIFT: '',
    beneficiaryBankName: '',
    beneficiaryBankAddress: '',
    beneficiaryBankCountry: '',
    correspondentBank: false,
    correspondentBankSWIFT: '',
    correspondentBankName: '',
    correspondentBankAddress: '',
    correspondentBankCountry: '',
    correspondentAccount: ''
  }
}
